module.exports = __webpack_public_path__ + "img/关于我们.bea576a1.jpg";